import { combineReducers } from 'redux'

// Import your reducers here
import assignments from './assignments'
import client from './client'
import forms from './forms'
import formWizard from './formWizard'
import locations from './locations'
import massAssignments from './massAssignments'
import newHireStatuses from './newHireStatuses'
import positions from './positions'
import versionHistory from './versionHistory'

export default combineReducers({
  // make sure to add imported reducer here
  assignments,
  client,
  forms,
  formWizard,
  locations,
  massAssignments,
  newHireStatuses,
  positions,
  versionHistory
})



// WEBPACK FOOTER //
// ./src/modules/Forms/reducers/index.js